import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { MatchService, ButtonService } from '../../services';
import { ButtonSet, Match, MediaSource } from '../../models';
import * as common from '../../common';
import { AngularFireAuth } from '@angular/fire/auth';

@Component({
  selector: 'add-game-dialog',
  templateUrl: './add-game-dialog.html',
  styles: ['.mat-form-field { display: block }']
})
export class AddGameDialogComponent implements OnInit {
  buttonsFormGroup: FormGroup;
  isLinear = true;
  propertiesFormGroup: FormGroup;
  userId: string;
  videoFormGroup: FormGroup;
  
  public buttonSets: ButtonSet[];
  public videoTypes = ['video/mp4'];
  
  constructor(
    private _fb: FormBuilder,
    public dialogRef: MatDialogRef<AddGameDialogComponent>,
    public matchService: MatchService,
    private buttonService: ButtonService,
    private authService: AngularFireAuth,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.propertiesFormGroup = this._fb.group({
      competitionName: ['', Validators.required],
      name: ['', Validators.required],
      roundNumber: [''],
      matchDate: ['', Validators.required],
      homeTeam: ['', Validators.required],
      awayTeam: ['', Validators.required],
      venue: ['']
    });

    this.buttonsFormGroup = this._fb.group({
      buttonSetId: null,
      folders: []
    });

    this.propertiesFormGroup.controls.matchDate.setValue(new Date());

    this.videoFormGroup = this._fb.group({
      src: [''],
      type: ['video/mp4']
    });

    this.authService.authState.subscribe(user => {
      if (user) {
        this.userId = user.uid;
        this.buttonService.getForUser(user.uid).subscribe(b => (this.buttonSets = b));
      }
    });
  }

  onSaveClick(): void {
    if (this.userId) {
      const src = common.getShareUrl(this.videoFormGroup.value.src);
      const matchDate = new Date(this.propertiesFormGroup.controls.matchDate.value).toString();

      const properties = { ...this.propertiesFormGroup.value, matchDate };

      const media = { ...this.videoFormGroup.value, src };
      const buttonSetId = this.buttonsFormGroup.controls.buttonSetId.value;
      const isCurrentPublished = false;
      const isPublished = false;

      const match = {
        ...properties,
        userId: this.userId,
        buttonSetId,
        events: [],
        media,
        isPublished,
        isCurrentPublished
      } as Match;

      const t = new Date(this.propertiesFormGroup.controls.matchDate.value);

      match.matchDate = t.toString();

      console.info('adding: ', match);

      this.matchService.add(match).subscribe(e => {
        this.dialogRef.close(e);
      });
    } else {
      alert('Match not created as User Id was not available.');
      console.error('User Id was not available.');
      this.dialogRef.close(null);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
